import type { HopTierMeta, SearchResponse } from "../api/types";

type Props = {
  result: SearchResponse;
  tier: HopTierMeta;
};

const Bar = ({
  label,
  value,
  cap,
}: {
  label: string;
  value: number;
  cap: number;
}) => {
  const pct = cap === 0 ? 0 : Math.min(100, (value / cap) * 100);
  return (
    <div className="flex items-center gap-2 min-w-[140px]">
      <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-white/40 w-14">
        {label}
      </span>
      <div className="flex-1 h-1.5 rounded-full bg-white/5 overflow-hidden">
        <div
          className="h-full rounded-full"
          style={{
            width: `${pct}%`,
            background:
              "linear-gradient(90deg, rgba(124,58,237,0.6), rgba(192,132,252,0.9))",
          }}
        />
      </div>
      <span className="font-mono text-[11px] text-white/60 tabular-nums w-12 text-right">
        {value}
        <span className="text-white/30">/{cap}</span>
      </span>
    </div>
  );
};

export const UsageStrip = ({ result, tier }: Props) => (
  <div className="panel rounded-xl px-4 py-3 flex flex-wrap items-center gap-x-6 gap-y-2">
    <div className="flex items-center gap-2">
      <span className="chip">{result.tier}</span>
      <span className="font-mono text-[11px] text-white/40">
        {result.hops_charged} hop{result.hops_charged === 1 ? "" : "s"}
      </span>
      <span
        className="chip"
        style={{
          color: result.paid_mode ? "#4ade80" : "rgba(255,255,255,0.5)",
          borderColor: result.paid_mode
            ? "rgba(74,222,128,0.3)"
            : "rgba(255,255,255,0.08)",
          background: result.paid_mode
            ? "rgba(74,222,128,0.06)"
            : "rgba(255,255,255,0.03)",
        }}
      >
        {result.paid_mode ? "paid" : "dev"}
      </span>
    </div>
    <Bar
      label="nodes"
      value={result.usage.nodes_returned}
      cap={tier.caps.maxNodes}
    />
    <Bar
      label="edges"
      value={result.usage.edges_returned}
      cap={tier.caps.maxEdges}
    />
    <Bar
      label="claims"
      value={result.usage.claims_returned}
      cap={tier.caps.maxClaims}
    />
    <span className="font-mono text-[11px] text-white/30 ml-auto">
      {result.sources.length} sources · {result.attribution.length} attributions
    </span>
  </div>
);
